import { call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* balanceFetch(action: ActionInterface): any {
  try {

    const res = yield call(Http.post, `balance`, action.payload);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchBalanceFetch() {
  yield takeEvery(Constants.BALANCE_FETCH, balanceFetch);
}
